module.exports = __webpack_public_path__ + "static/media/ic-close-gray-24-px.4ea7bfc8.svg";